<template>
  <div class="widget-button-list">
    <button v-for="(b, i) in list"
            :class="['widget-button', {selected: i === selectedIndex}]"
            :style="buttonStyle"
            @click="selectButton(i)">
      {{b}}
    </button>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    list: {
      type: Array
    }
  },
  data () {
    return {
      selectedIndex: 0
    }
  },
  computed: {
    buttonStyle () {
      let width = 100/this.list.length

      return {
        width: width + '%'
      }
    }
  },
  methods: {
    selectButton(index) {
      this.selectedIndex = index

      this.$emit('select', {
        index,
        button: this.list[index]
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// BUttonList.vue?69932a4a